import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule } from './autoComplete/autoComplete.module';
import { EditButtonComponent } from './listGrid/editButton/editButton.component';
import { ChipsInputModule } from './chipsInput/chipsInput.module';
import { MainPipe } from './pipes/pipes.module';
import { AppMaterialModule } from './appMaterial/app-material.module';
import { SignUpFormModule } from './sign-up-form/sign-up-form.module';
import { EnrollEmailDuplicateModule } from './enrollEmailDuplicate/enroll-email-duplicate.module';
import { EqualValidatorModule } from './equalValidator/equal-validator.module';
import { ApproveButtonComponent } from './listGrid/approveButton/approveButton.component';
import { RejectButtonComponent } from './listGrid/rejectButton/rejectButton.component';
import { ViewButtonComponent } from './listGrid/viewButton/viewButton.component';
import { DownloadButtonComponent } from './listGrid/downloadButton/downloadButton.component';
import { FileOpenButtonComponent } from './listGrid/fileOpenButton/fileOpenButton.component';
import { MinDirectiveModule } from './minValidator/minDirective.module';
import { MaxDirectiveModule } from './maxValidator/maxDirective.module';
import { CheckboxQuestionListComponent } from './checkbox-list/checkbox-question-list.component';
import { ApproveRejectButtonComponent } from './listGrid/approveRejectButton/approve-reject-button.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TosContentModule } from './public-components/tos-content/tos-content.module';
import { PrivacyPolicyContentModule } from './public-components/privacy-policy-content/privacy-policy-content.module';
import { AppMarkerMapComponent } from './app-marker-map/app-marker-map.component';
import { AppMarkerMapModule } from './app-marker-map/app-marker-map.module';
import { MyChartersCardModule } from './my-charters-card/my-charters-card.module';
import { NumbersOnlyDirective } from './directives/number-only-directives/numbers-only.directive';
import { TwoDigitDecimalNumberDirective } from './directives/number-only-directives/two-digit-decimal-number.directive';
import { MilitaryTimeToStringPipe } from './pipes/military-to-string.pipe';
import { GoogleMapsModule } from '@angular/google-maps';
import { NameEditButtonComponent } from '../portal/profile/captain/boatyard/form/services-and-pricing/line-item-actions/nameEditButton/nameEditButton.component';
import { DeleteButtonComponent } from '../portal/profile/captain/boatyard/form/services-and-pricing/line-item-actions/deleteButton/deleteButton.component';
import { CustomPriceComponent } from '../portal/profile/captain/boatyard/form/services-and-pricing/line-item-actions/customPrice/customPrice.component';
import { hasSplitsButtonComponent } from '../portal/profile/captain/boatyard/form/services-and-pricing/line-item-actions/hasSplitsButton/nameEditButton.component';
import { PhonePipe } from './pipes/phone/phone.pipe';

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AppMaterialModule,
    AutoCompleteModule,
    ChipsInputModule,
    MainPipe,
    SignUpFormModule,
    EqualValidatorModule,
    MinDirectiveModule,
    MaxDirectiveModule,
    FormsModule,
    MatSlideToggleModule,
    TosContentModule,
    PrivacyPolicyContentModule,
    AppMarkerMapModule,
    GoogleMapsModule,
  ],
  declarations: [
    EditButtonComponent,
    NameEditButtonComponent,
    hasSplitsButtonComponent,
    DeleteButtonComponent,
    CustomPriceComponent,
    ApproveButtonComponent,
    RejectButtonComponent,
    ViewButtonComponent,
    ApproveRejectButtonComponent,
    CheckboxQuestionListComponent,
    AppMarkerMapComponent,
    NumbersOnlyDirective,
    TwoDigitDecimalNumberDirective,
    DownloadButtonComponent,
    FileOpenButtonComponent,
    MilitaryTimeToStringPipe,
    PhonePipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AutoCompleteModule,
    ChipsInputModule,
    MainPipe,
    EnrollEmailDuplicateModule,
    SignUpFormModule,
    EqualValidatorModule,
    MinDirectiveModule,
    MaxDirectiveModule,
    CheckboxQuestionListComponent,
    AppMaterialModule,
    TosContentModule,
    PrivacyPolicyContentModule,
    AppMarkerMapModule,
    AppMarkerMapComponent,
    MyChartersCardModule,
    NumbersOnlyDirective,
    TwoDigitDecimalNumberDirective,
    MilitaryTimeToStringPipe,
    PhonePipe,
  ],
  providers: [],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [],
    };
  }
}
